import React, { useEffect, useRef } from "react";
import { Button } from "antd";
import { FiArrowUpRight } from "react-icons/fi";

const ButtonBox = ({
  children,
  type = "primary",
  loader,
  style,
  label,
  leftIcon,
  rightArrowIcon,
  rightIcon,
  className,
  size,
  ghost,
  href,
  onClick,
  refs,
}) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (refs) refs(buttonRef.current);
    return () => {
      if (refs) refs(null);
    };
  }, [refs]);

  const handleClick = () => {
    if (!loader && onClick) {
      onClick();
    }
  };

  return (
    <Button
      ref={buttonRef}
      style={style}
      onClick={handleClick}
      type={type}
      loading={loader}
      className={className}
      size={size}
      ghost={ghost}
      href={href}
    >
      {leftIcon && <span className="me-1">{leftIcon}</span>}
      {label}
      {children}
      {rightIcon && <span className="ms-1">{rightIcon}</span>}
      {rightArrowIcon && (
        <span className="ms-1 arrow-right">
          <FiArrowUpRight size={18} />
        </span>
      )}
    </Button>
  );
};

export default ButtonBox;
